import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
const compareArrays = (arr1 = false, arr2 = false) => {
    if (!arr1 || !arr2) return true;
    if (arr1.length === 0 || arr2.length === 0) return true;
    let flag = false;
    arr1.map((a) => {
        if (arr2.includes(a)) flag = true;
        return null;
    });
    return flag;
};
const createSelectors = (parentReducer) => {
    return new (class {
        selectUsers = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.users;
        };
        selectDepartments = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.departments;
        };
        selectAreas = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.areas;
        };
        setAreas = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.areaType;
        };
        setDepartments = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.departmentType;
        };
        selectPage = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.page;
        };
        selectProfile = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.userProfile;
        };
        selectLoggedProfileEmail = (store) => {
            const pageReducer = store["MainReducer"];
            return pageReducer.profile ? pageReducer.profile.email : false;
        };
        selectRow = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.row;
        };
        selectFilter = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.filter;
        };
        selectUserFilter = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.userFilter;
        };
        selectLastActive = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.lastActive;
        };
        getRequesting = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerV4TableDataWidget_reducer"];
            return reducer.requesting;
        };
        selectAllUserEmails = createSelector(
            [this.selectUsers],
            (users = false) => {
                if (users) {
                    let emails = _.compact(
                        Object.keys(users).map((e) =>
                            !_.get(users[e].profile, "deleted")
                                ? _.get(users[e].profile, "email")
                                : false
                        )
                    );
                    return emails;
                } else {
                    return [];
                }
            }
        );

        compareArrays = (arr1 = false, arr2 = false) => {
            if (!arr1 || !arr2) return true;
            if (arr1.length === 0 || arr2.length === 0) return true;
            let flag = false;
            arr1.map((a) => {
                arr2.map((b) => {
                    if (a === b) flag = true;
                    return null;
                });
                return null;
            });
            return flag;
        };
        selectUserInfo = createSelector(
            [
                this.selectUsers,
                this.selectFilter,
                this.selectProfile,
                this.setAreas,
                this.setDepartments,
                this.selectUserFilter,
                this.selectLastActive,
            ],
            (
                users = false,
                filter = "admin",
                profile = false,
                areaType = false,
                departmentType = false,
                userFilter = false,
                lastActive = false
            ) => {
                if (users && profile) {
                    let userProfiles = _.compact(
                        Object.keys(users).map((e) => {
                            let deleted =
                                _.get(users[e], "profile.deleted") || false;
                            let userType =
                                _.get(users[e], "profile.user_type") || "admin";
                            let areas =
                                _.get(users[e], "profile.areas") || false;
                            let departments =
                                _.get(users[e], "profile.departments") || false;

                            let userAreasValid =
                                areas && profile.areas
                                    ? compareArrays(areas, profile.areas)
                                    : true;
                            let userDeptsValid =
                                departments && profile.departments
                                    ? compareArrays(
                                          departments,
                                          profile.departments
                                      )
                                    : true;
                            if (
                                !deleted &&
                                userType === filter &&
                                userAreasValid &&
                                userDeptsValid
                            ) {
                                return _.get(users[e], "profile") || false;
                            } else return false;
                        })
                    );
                    if (areaType !== "all_areas") {
                        userProfiles = userProfiles.filter((e) => {
                            let isAvvailable = false;
                            if (e.areas)
                                e.areas.map((f) => {
                                    if (f === areaType) isAvvailable = true;
                                    return null;
                                });
                            else return true;
                            return isAvvailable;
                        });
                    }

                    if (departmentType !== "all_departments") {
                        userProfiles = userProfiles.filter((e) => {
                            let isAvailable = false;
                            if (e.departments)
                                e.departments.map((f) => {
                                    if (f === departmentType)
                                        isAvailable = true;
                                    return null;
                                });
                            else return true;
                            return isAvailable;
                        });
                    }

                    if (lastActive) {
                        let refArray = [];
                        userProfiles = userProfiles.filter((e) => {
                            let refObj = e;
                            let refdate = moment(
                                e.last_active,
                                "DD-MM-YYYY HH:mm:ss"
                            );
                            refObj["utc"] = parseInt(
                                (new Date(refdate).getTime() / 1000).toFixed(0)
                            );
                            refArray.push(refObj);
                            return null;
                        });
                        return _.orderBy(refArray, "utc", ["desc"]);
                    }

                    if (userFilter) {
                        userProfiles = userProfiles.filter((e) => {
                            let name = `${e.first_name.toLowerCase()} ${e.last_name.toLowerCase()}`;
                            return name.includes(userFilter.toLowerCase());
                        });
                    }
                    //to hide wolf's account for non prowork domain users
                    var email = profile.email;
                    var index = email.indexOf("@");
                    var domain = email.slice(index + 1, email.length);

                    if (domain !== "prowork.ie") {
                        for (var i = 0; i < userProfiles.length; i++) {
                            if (userProfiles[i].email === "wolf@prowork.ie") {     
                                userProfiles.splice(i, 1);
                            }
                        }
                        
                    }
                    return userProfiles.sort((a, b) =>
                        a.first_name.localeCompare(b.first_name)
                    );
                    //return _.orderBy(userProfiles, "first_name", "asc");
                } else return false;
            }
        );
    })();
};

export default createSelectors;
